import {
  predictionControllerReindex,
  unwrapApiResponse,
} from "@cryptors/api-client";
import { useMutation } from "@tanstack/react-query";

const postReindexCryptors = () => {
  return unwrapApiResponse(
    predictionControllerReindex<true>({
      throwOnError: true,
    }),
  );
};

export const usePostReindexCryptors = () => {
  return useMutation({
    mutationKey: ["prediction"],
    mutationFn: postReindexCryptors,
  });
};
